import script from "./AudioEditorMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioEditorMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./AudioEditorMolecule.vue?vue&type=style&index=0&id=744cda32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-744cda32"]])

export default __exports__